import React from 'react';
import { IIcon } from './types';

export default function ShowPassword({
  style = {},
  fill = '#CCCCCC',
  width = '2rem',
  height = '1.263rem',
  className = 'show-password',
  viewBox = '0 0 20 13'
}: IIcon) {
  return (
    <svg
      style={style}
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      className={`svg-icon ${className}`}
      xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_33_814" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.314C4.00889 -2.10467 15.9911 -2.10467 20 6.314C15.9911 14.7327 4.00889 14.7327 0 6.314ZM10 11.314C12.7614 11.314 15 9.07543 15 6.314C15 3.55258 12.7614 1.314 10 1.314C7.23858 1.314 5 3.55258 5 6.314C5 9.07543 7.23858 11.314 10 11.314Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.314C4.00889 -2.10467 15.9911 -2.10467 20 6.314C15.9911 14.7327 4.00889 14.7327 0 6.314ZM10 11.314C12.7614 11.314 15 9.07543 15 6.314C15 3.55258 12.7614 1.314 10 1.314C7.23858 1.314 5 3.55258 5 6.314C5 9.07543 7.23858 11.314 10 11.314Z"
        fill="black"
      />
      <path
        d="M0 6.314L-0.902861 5.88407L-1.10759 6.314L-0.902861 6.74394L0 6.314ZM20 6.314L20.9029 6.74394L21.1076 6.314L20.9029 5.88407L20 6.314ZM0.902861 6.74394C4.5498 -0.914645 15.4502 -0.914645 19.0971 6.74394L20.9029 5.88407C16.532 -3.29469 3.46798 -3.29469 -0.902861 5.88407L0.902861 6.74394ZM19.0971 5.88407C15.4502 13.5426 4.5498 13.5426 0.902861 5.88407L-0.902861 6.74394C3.46798 15.9227 16.532 15.9227 20.9029 6.74394L19.0971 5.88407ZM14 6.314C14 8.52314 12.2091 10.314 10 10.314V12.314C13.3137 12.314 16 9.62771 16 6.314H14ZM10 2.314C12.2091 2.314 14 4.10486 14 6.314H16C16 3.00029 13.3137 0.314002 10 0.314002V2.314ZM6 6.314C6 4.10486 7.79086 2.314 10 2.314V0.314002C6.68629 0.314002 4 3.00029 4 6.314H6ZM10 10.314C7.79086 10.314 6 8.52314 6 6.314H4C4 9.62771 6.68629 12.314 10 12.314V10.314Z"
        fill="black"
        mask="url(#path-1-inside-1_33_814)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 6.31396C8.32843 6.31396 9 5.64239 9 4.81396C9 4.37607 8.81236 3.982 8.5131 3.70778C8.95139 3.45718 9.45897 3.31396 10 3.31396C11.6569 3.31396 13 4.65711 13 6.31396C13 7.97082 11.6569 9.31396 10 9.31396C8.34315 9.31396 7 7.97082 7 6.31396C7 6.28556 7.00039 6.25724 7.00118 6.22903C7.15724 6.28404 7.32512 6.31396 7.5 6.31396Z"
        fill="black"
      />
    </svg>
  );
}
